import styled, { css } from 'styled-components';

export const fontSizing = css`
  font-size: 14px;
  line-height: 150%;
`;

export const Label = styled.p<{ $lg?: boolean; $center?: boolean }>`
  ${fontSizing}
  font-weight: 600;
  color: #1d1c1d;
  margin-bottom: 8px;
  ${({ $lg = false }) => $lg && 'line-height: 32px;'}
  ${({ $center = false }) => $center && 'text-align: center;'}
`;

export const Subtitle = styled.p`
  ${fontSizing}
  color: ${({ theme }) => theme.colors['neutral-100']};
  margin-bottom: 16px;
`;

export const Details = styled.p`
  ${fontSizing}
  color: ${({ theme }) => theme.colors['neutral-80']};
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  margin-bottom: 16px;
`;

export const Separator = styled.div<{ $lg?: boolean }>`
  display: flex;
  gap: ${({ $lg = false }) => ($lg ? 16 : 8)}px;

  & > * {
    width: 50%;
  }
`;

export const QuantitiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QuantityField = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  & > * {
    width: 50%;
  }
`;

export const QuantityLabel = styled.p`
  ${fontSizing}
  color: #1D1C1D;
`;

export const Footer = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 16px;
  justify-content: center;
`;

export const ConfirmationSeparator = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const ConfirmationText = styled.p`
  ${fontSizing};
  color: #1d1c1d;
  display: block;

  & strong {
    font-weight: 600;
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: 20px;
`;
